// extracted by mini-css-extract-plugin
export default {"seriesPreviewPhoto":"SeriesPreviewPhoto_seriesPreviewPhoto__AAzbT"};